import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";
import { CONSTANT } from "../../config/Constant";

export const getUsers = createAsyncThunk(
  "User/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      const params = new URLSearchParams();

      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          // If the value is an array, append each item with the same key
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          // For non-array values, just append normally
          params.append(key, value);
        }
      }
      const queryString = params.toString();

      const { data } = await axios.get(`${API_URL.USER.SLUG}?${queryString}`);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createUser = createAsyncThunk(
  "User/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${API_URL.USER.CREATE_USER}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const deleteUser = createAsyncThunk(
  "User/delete",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(`${API_URL.USER.SLUG}/${id}`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const editUser = createAsyncThunk(
  "User/put",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(`${API_URL.USER.SLUG}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState: {
    user_list: [],
    current_values: null,
    active_payload: null,
    selectedUserType: CONSTANT.ROLE_TYPE.BACKOFFICE,
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
    resetCurrentValue(state) {
      state.current_values = null;
    },
    setSelectedUserType(state, action) {
      state.selectedUserType = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUsers.fulfilled, (state, action) => {
      state.user_list = action.payload.data.list;
    });
  },
});

export const {
  setCurrentValues,
  setActivePayload,
  resetCurrentValue,
  setSelectedUserType,
} = userSlice.actions;
export default userSlice.reducer;
